<template>
  <a-modal
    :title="title"
    :width="1450"
    :visible="visible"
    :footer="null"
    @cancel="
      () => {
        this.isopen = false;
        $emit('cancel', this.isopen);
      }
    "
  >
    <a-spin :spinning="loading">
      <!-- <div id="mychart"></div> -->
      <a-button
        :title="isopen ? '收缩' : '展开'"
        type="primary"
        shape="circle"
        style="float: right; z-index: 2"
        @click="change"
        >{{ isopen ? "-" : "+" }}</a-button
      >
        <!-- <div id="lossChart" style="width: 90%; height: 300px"></div> -->
      
      <a-table
        :scroll="{ y: 800 }"
        rowKey="id"
        :columns="columns"
        :data-source="data"
        :pagination="false"
      >
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from "lodash.pick";
import { requestUrl } from "@/utils/request_url";

export default {
  name: "ProjectForm",
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    ldata: {
      type: Array,
      default: () => null,
    },
    lcolumns: {
      type: Array,
      default: () => null,
    },
    title: {
      type: String,
      default: "新增",
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      headers: {},
      columns: [
        // {
        //   dataIndex: 'lr',
        //   key: 'lr',
        //   title: 'LR',
        //   scopedSlots: { customRender: 'name' },
        // },
        // {
        //   title: 'EPOCH',
        //   dataIndex: 'epoch',
        //   key: 'epoch',
        // },
        // {
        //   title: 'STEP',
        //   dataIndex: 'step',
        //   key: 'step',
        // },
        // {
        //   title: 'LOSS',
        //   key: 'loss',
        //   dataIndex: 'loss',
        // },
        // {
        //   title: 'TEST_RECALL',
        //   key: 'test_recall',
        //   dataIndex: 'test_recall',
        // },
        //  {
        //   title: 'TEST_PRECISION',
        //   key: 'test_precision',
        //   dataIndex: 'test_precision',
        // },
        // {
        //   title: 'TRAIN_ACCURACY',
        //   key: 'train_accuracy',
        //   dataIndex: 'train_accuracy',
        // },
        //  {
        //   title: 'VAL_ACCURACY',
        //   key: 'val_accuracy',
        //   dataIndex: 'val_accuracy',
        // },
        // {
        //   title: '时间',
        //   key: 'createTime',
        //   dataIndex: 'createTime',
        // },
      ],
      data: [],
      dom: null,
      xData: ["周一", "周二", "周三", "周四"],
      yData: [1, 2, 3, 4],
      isopen: false,
      myChart: null,
    };
  },
  created() {
    // this.$nextTick(() => {
    // })
  },
  watch: {
    ldata: function (newValue, oldValue) {
      // const that = this;
      this.data = newValue;
      // this.xData = this.xdataValue(this.data);
      // this.yData = this.ydataValue(this.data);
      // this.myChart.setOption({
      //   xAxis: {
      //     data: that.xData,
      //   },
      //   series: [
      //     {
      //       data: that.yData,
      //     },
      //   ],
      // });
    },
    lcolumns: function (nev, oldv) {
      this.columns = nev;
    },
    // visible(newv, oldv) {
    //   const self = this;
    //   if (newv) {
    //     this.$nextTick(() => {
    //       self.drawChart();
    //     });
    //   } else {
    //     this.myChart.dispose();
    //   }
    // },
  },
  computed: {},
  mounted() {
    const self = this;
    // setTimeout(() => {
    //   console.log(111);
    //     self.drawChart()
    // }, 2000);
  },
  methods: {
    stopscroll(){
      document.onscroll = function(e) {
        e.preventDefault()
      }
    },
    init() {},
    change() {
      this.isopen = !this.isopen;
      this.$emit("isopen", this.isopen);
    },
    drawChart() {
      const that = this;
      this.myChart = this.$echarts.init(document.getElementById("lossChart"));
      let option = {
        title: {
          text: "loss",
        },
        dataZoom:[{
    type: 'inside', // 放大和缩小
    orient: 'vertical',
   },{
    type: 'inside', 
   }],
        tooltip: {
          formatter: "loss:{c}",
        },
        xAxis: {
          type: "category",
          data: that.xData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: that.yData,
            type: "line",
          },
        ],
      };

      this.myChart.setOption(option);
      // 使用刚指定的配置项和数据显示图表。
    },
    xdataValue(values) {
      var data = values.map((item) => {
        return item.createTime;
      });
      return data.reverse();
    },
    ydataValue(values) {
      var data = values.map((item) => {
        return parseFloat(item.loss);
      });
      return data.reverse();
    },
  },
};
</script>

<style scoped>
.ant-table-body {
  overflow-y: auto !important;
}
</style>
